/**
 * Shared style + config constants for /docs/* pages. Separated from
 * DocsLayout.jsx so fast-refresh can hot-reload the component without
 * invalidating constant imports (react-refresh/only-export-components).
 */

const INK = '#0a0a0a';

// Table of contents — the single source of truth for doc pages + order.
// Add new pages here first, then create the file. Sidebar + next/prev
// navigation in DocsLayout reads from this list. Description + keywords
// power the in-app HelpWidget search + CommandPalette (Day 5).
export const DOC_PAGES = [
  {
    path: '/docs/first-project',
    title: 'Creating your first project',
    description: 'Scope, team size, rate range, SLA — walk through the form.',
    keywords: ['project', 'create', 'new', 'job', 'start', 'scope'],
  },
  {
    path: '/docs/invite-team',
    title: 'Inviting your team',
    description: 'Who can invite whom, how invites land, admin vs SPL permissions.',
    keywords: ['invite', 'team', 'annotator', 'spl', 'admin', 'onboard'],
  },
  {
    path: '/docs/batch-qa',
    title: 'Running QA on a batch',
    description: 'Review workflow, overlap batches, quality scores, rejection flow.',
    keywords: ['qa', 'quality', 'batch', 'review', 'overlap', 'accept', 'reject'],
  },
  {
    path: '/docs/client-report',
    title: 'Generating a client report',
    description: 'Pull together metrics + deliverables + sign-off for a client.',
    keywords: ['report', 'client', 'export', 'deliverable', 'pdf'],
  },
  {
    path: '/docs/billing-plans',
    title: 'Billing and plans',
    description: 'Plan tiers, invoicing cadence, upgrade path, Stripe vs manual.',
    keywords: ['billing', 'plan', 'invoice', 'payment', 'stripe', 'pricing'],
  },
];

// Shared styles for doc prose
export const sectionTitle = {
  fontSize: 20, fontWeight: 600, margin: '36px 0 12px',
  color: INK, letterSpacing: '-0.01em',
};
export const subTitle = {
  fontSize: 16, fontWeight: 600, margin: '28px 0 8px',
  color: INK,
};
export const para = {
  margin: '0 0 16px',
};
export const callout = (variant = 'info') => ({
  margin: '20px 0',
  padding: '14px 16px',
  borderRadius: 8,
  fontSize: 14,
  lineHeight: 1.55,
  background: variant === 'warn' ? '#FEF3C7' : '#ECFDF5',
  border: `1px solid ${variant === 'warn' ? '#FCD34D' : '#A7F3D0'}`,
  color: variant === 'warn' ? '#92400E' : '#065F46',
});
export const kbd = {
  display: 'inline-block',
  padding: '2px 6px',
  fontSize: 12,
  fontFamily: "'JetBrains Mono', monospace",
  background: '#f3f4f6',
  border: '1px solid #d1d5db',
  borderRadius: 4,
  lineHeight: 1.2,
};
